import { Content, Editor, JSONContent } from '@tiptap/react';
import { CustomFloatingToolbarConfig } from '../types';
import { EditorFloatingToolbarConfig } from '../types';

export const isCustomToolbarConfig = (
  config: EditorFloatingToolbarConfig,
): config is CustomFloatingToolbarConfig => {
  return 'toolbar' in config;
};
export const isStringContent = (content: Content): content is string =>
  typeof content === 'string';
export const isEditorContentEqual = (
  editor: Editor,
  content: Content,
): boolean => {
  if (isStringContent(content)) {
    return content === editor.getHTML();
  }

  return JSON.stringify(content) === JSON.stringify(editor.getJSON());
};
export const getScrollableParent = (element: HTMLElement | null) => {
  if (!element || element === document.documentElement) {
    return null;
  }

  if (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  ) {
    return element;
  }

  if (element.parentElement) {
    return getScrollableParent(element.parentElement);
  }

  return null;
};
export const isTiptapJsonEmpty = (tiptapJson: JSONContent) => {
  return (
    (tiptapJson.content?.length ?? 0) === 0 ||
    !tiptapJson.content?.some(
      (node) =>
        node.type === 'RL_CUSTOM_SECTION' || (node.content?.length ?? 0) > 0,
    )
  );
};
